import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackCountrysideTrapClick, trackCountrysideTrapShow } from './tracking';
import { CountrysideTrapBanner } from '../../serp/components/CountrysideTrapBanner';
import { selectVillagesLink } from 'shared/selectors';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

export const CountrysideTrapBannerContainer: React.FC = () => {
  const villagesLink = useSelector(selectVillagesLink);

  const jsonQuery = useSelector(getJsonQuery);

  const handleClick = React.useCallback(() => {
    trackCountrysideTrapClick(jsonQuery);
  }, [jsonQuery]);

  const handleShow = React.useCallback(() => {
    trackCountrysideTrapShow(jsonQuery);
  }, [jsonQuery]);

  if (!villagesLink) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow} percentVisible={0.8} triggerOnce>
      <CountrysideTrapBanner onClick={handleClick} villagesLink={villagesLink} />
    </ActionAfterViewObserver>
  );
};
